// components/voice/VadModeSelector.tsx
import { Radio, Sparkles } from 'lucide-react';
import { VadMode } from '../../contexts/voice/types';

interface VadModeSelectorProps {
  vadMode: VadMode;
  onSelect: (mode: VadMode) => void;
  className?: string;
}

const VAD_MODES = [
  {
    id: 'standard' as VadMode,
    label: 'Default',
    description: 'Default voice detection',
    icon: Radio,
  },
  {
    id: 'gl31' as VadMode,
    label: 'GL31',
    description: 'Gemini 3.1 Flash Live',
    icon: Sparkles,
  },
] as const;

export function VadModeSelector({ vadMode, onSelect, className = '' }: VadModeSelectorProps) {
  return (
    <div className={`flex items-center gap-1 p-1 rounded-full bg-card border border-primary/20 shadow-lg ${className}`}>
      {VAD_MODES.map((mode) => {
        const Icon = mode.icon;
        const isActive = vadMode === mode.id;
        return (
          <button
            key={mode.id}
            onClick={() => onSelect(mode.id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
              isActive
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
            title={mode.description}
          >
            <Icon className="w-3 h-3" />
            {mode.label}
          </button>
        );
      })}
    </div>
  );
}
